import cloneDeep from 'lodash.clonedeep';
import { connectedStore } from '../../store';
import selectors from '../selectors';

const getBlockSettings = (blockId, palette) => {
  const store = connectedStore.get();
  const state = store.getState();

  const blockSettings = cloneDeep(selectors.getBlockSettings(state, blockId, palette));

  if (!blockSettings) return null;

  return blockSettings;
};

export default getBlockSettings;
